/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {AsideMenuItemWithSubMain} from './AsideMenuItemWithSubMain'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {checkPermission} from '../../../../app/App'
type PROPS = {
  isMinified: boolean
}

export function AsideMenuMain({isMinified}: PROPS) {
  const intl = useIntl()

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        title='Dashboard'
        icon='/media/ePulse/icons/aside/dashboard.svg'
        heading='Home'
        className='py-3'
        isMinified={isMinified}
      ></AsideMenuItem>
      {(checkPermission('getAdminUserList') ||
        checkPermission('getSystemRoleList') ||
        checkPermission('getSystemModuleList') ||
        checkPermission('getErrorLogList') ||
        checkPermission('getEnrollReqUserList') ||
        checkPermission('getSystemRoleList')) && (
        <AsideMenuItemWithSubMain
          to='/adminsection'
          title='Admin'
          icon='/media/ePulse/icons/aside/user.svg'
          heading='Admin'
          isMinified={isMinified}
        >
          {checkPermission('getSystemRoleList') && (
            <AsideMenuItem
              to='/roles_permissions'
              title='Roles & Permissions'
              isMinified={isMinified}
            />
          )}
          {checkPermission('getAdminUserList') && (
            <AsideMenuItem to='/admin' title='Admin' isMinified={isMinified} />
          )}
          {/* {checkPermission('getSystemRoleList') && (
            <AsideMenuItem to='/system_role' title='System Role' />
          )} */}
          {/* {checkPermission('getRoleModuleList') && (
            <AsideMenuItem to='/super_admin_role' title='Super Admin Roles' />
          )} */}
          {checkPermission('getSystemModuleList') && (
            <AsideMenuItem to='/system_module' title='System Module' isMinified={isMinified} />
          )}
          {checkPermission('getErrorLogList') && (
            <AsideMenuItem to='/error_logging' title='Error Logging' isMinified={isMinified} />
          )}
          {checkPermission('getEnrollReqUserList') && (
            <AsideMenuItem to='/website_enquiry' title='Marketing Website Enquiry' />
          )}
        </AsideMenuItemWithSubMain>
      )}
      {(checkPermission('getApplicationSettings') ||
        checkPermission('getPaginationPolicyList') ||
        checkPermission('getPaginationHolidayList') ||
        checkPermission('getApprovalStepsPaginationList') ||
        checkPermission('getNotificationTemplateListByType')) && (
        <AsideMenuItemWithSubMain
          to='/settingssection'
          title='Settings'
          icon='/media/ePulse/icons/aside/setting.svg'
          heading='Settings'
          isMinified={isMinified}
        >
          {checkPermission('getApplicationSettings') && (
            <AsideMenuItem
              to='/application_setting/auth'
              title='Application Setting'
              // bsTitle='Application Setting'
              isMinified={isMinified}
            />
          )}
          {checkPermission('getPaginationPolicyList') && (
            <AsideMenuItem
              to='/application_policy'
              title='Application Policies'
              // bsTitle='Application Policies'
              isMinified={isMinified}
            />
          )}
          {checkPermission('getPaginationHolidayList') && (
            <AsideMenuItem
              to='/holiday_settings'
              title='Holidays Setting'
              // bsTitle='Holidays Setting'
              isMinified={isMinified}
            />
          )}
          {checkPermission('getApprovalStepsPaginationList') && (
            <AsideMenuItem
              to='/approval_business_steps'
              title='Approval/Business Steps'
              // bsTitle='Approval/Business Steps'
              isMinified={isMinified}
            />
          )}
          {(checkPermission('getNotificationTemplateListByType') ||
            checkPermission('getNotificationModuleList') ||
            checkPermission('getRequestNotificationTemplateChangesList')) && (
            // || checkPermission('getRequestNotificationTemplateChangesList')
            <AsideMenuItem
              to='/notification_setting/template'
              title='Notification'
              // bsTitle='Application Policies'
              isMinified={isMinified}
            />
          )}
        </AsideMenuItemWithSubMain>
      )}
      {/* {(checkPermission('getPaginationPlanList') ||
        checkPermission('getPaginationServiceList') ||
        checkPermission('getAddonPaginationServiceList') ||
        checkPermission('getPlanServiceList') ||
        checkPermission('getPaginationPlanPricingList')) && (
        <AsideMenuItemWithSubMain
          to='/plansection'
          title='Billing'
          fontIcon='bi-sticky'
          icon='/media/ePulse/icons/aside/bill.svg'
          // bsTitle='Billing'
          heading='Billing'
        >
          {checkPermission('getPaginationPlanList') && <AsideMenuItem to='/plan' title='Plan' />}
          {checkPermission('getPaginationServiceList') && (
            <AsideMenuItem to='/service' title='Service' />
          )}
          {checkPermission('getAddonPaginationServiceList') && (
            <AsideMenuItem to='/addon_service' title='Add-On Service' />
          )}
          {checkPermission('getPlanServiceList') && (
            <AsideMenuItem to='/servicetoplan' title='Add Service to Plan' />
          )}
          {checkPermission('getPaginationPlanPricingList') && (
            <AsideMenuItem to='/planfrequency' title='Plan Frequency Pricing' />
          )}
        </AsideMenuItemWithSubMain>
      )} */}
      {(checkPermission('getPaginationRxTemplateList') ||
        checkPermission('getNotCertifiedDoctorList') ||
        checkPermission('getPaginationLaboratoryTestList') ||
        checkPermission('getDoctorSpecialtyList') ||
        checkPermission('getStateCouncilList') ||
        checkPermission('getMedicineList') ||
        checkPermission('getDiseaseList') ||
        checkPermission('getSymptomList') ||
        checkPermission('getPaginationAdviceList')) && (
        <AsideMenuItemWithSubMain
          to='/medicals'
          title='Medicine'
          fontIcon='bi-sticky'
          icon='/media/ePulse/icons/aside/rx-medicine.svg'
          heading='Doctor'
          isMinified={isMinified}
        >
          {checkPermission('getPaginationRxTemplateList') && (
            <AsideMenuItem
              to='/rx_module'
              title='RX Template'
              isMinified={isMinified}
              // bsTitle='Application Setting'
            />
          )}
          {checkPermission('getNotCertifiedDoctorList') && (
            <AsideMenuItem
              to='/non_approved_doctor'
              title='Non-Approved Doctors'
              isMinified={isMinified}
            />
          )}
          {checkPermission('getDoctorSpecialtyList') && (
            <AsideMenuItem
              to='/doctor_speciality'
              title='Doctor Speciality'
              isMinified={isMinified}
            />
          )}
          {checkPermission('getStateCouncilList') && (
            <AsideMenuItem to='/state_council' title='State Council' isMinified={isMinified} />
          )}

          {checkPermission('getSymptomList') && (
            <AsideMenuItem to='/symptom' title='Complaints/Symptoms' isMinified={isMinified} />
          )}
          {checkPermission('getConsumerComplains') && (
            <AsideMenuItem to='/complaints' title='Consumer Complaints' isMinified={isMinified} />
          )}
          {checkPermission('getMasterVaccineList') && (
            <AsideMenuItem to='/vaccination' title='Vaccinations' isMinified={isMinified} />
          )}
          {checkPermission('getDiseaseList') && (
            <AsideMenuItem to='/disease' title='Diseases/Diagnosis' isMinified={isMinified} />
          )}

          {checkPermission('getMedicineList') && (
            <AsideMenuItem to='/rx-medicine' title='RX Medicine' isMinified={isMinified} />
          )}
          {checkPermission('getPaginationLaboratoryTestList') && (
            <AsideMenuItem to='/test_requested' title='Test Requested' isMinified={isMinified} />
          )}
          {checkPermission('getPaginationAdviceList') && (
            <AsideMenuItem to='/advice' title='Advice' isMinified={isMinified} />
          )}
        </AsideMenuItemWithSubMain>
      )}
      {
        // checkPermission('') ||
        ((checkPermission('getTotalTransactionHistory') &&
          checkPermission('getTotalTransactionGraphHistory')) ||
          checkPermission('getOrderPaymentHistoryList') ||
          checkPermission('getBusinessTransactionList') ||
          checkPermission('getSettlementList') ||
          checkPermission('getEpulsePaymentFeesList') ||
          checkPermission('createLatestBusinessBankAccountsCsv') ||
          checkPermission('getBusinessAccountStatement')) && (
          <AsideMenuItemWithSubMain
            to='/summary'
            title='Transactions'
            fontIcon='bi-sticky'
            icon='/media/ePulse/icons/aside/inventory.png'
            heading='Transactions'
            isMinified={isMinified}
          >
            {checkPermission('getEpulsePaymentFeesList') && (
              <AsideMenuItem
                to='/fees-setting'
                title='Fees/Taxes Setting'
                isMinified={isMinified}
              />
            )}
            {checkPermission('getTotalTransactionHistory') &&
              checkPermission('getTotalTransactionGraphHistory') && (
                <AsideMenuItem to='/summary' title='Summary' isMinified={isMinified} />
              )}
            {checkPermission('getOrderPaymentHistoryList') && (
              <AsideMenuItem to='/payments' title='Payments' isMinified={isMinified} />
            )}
            {checkPermission('getSuperAdminRefundList') && (
              <AsideMenuItem to='/refunds' title='Refunds' isMinified={isMinified} />
            )}
            {checkPermission('getBusinessTransactionList') && (
              <AsideMenuItem to='/transactions' title='Transactions' isMinified={isMinified} />
            )}
            {checkPermission('getSettlementList') && (
              <AsideMenuItem to='/settlements' title='Settlements' isMinified={isMinified} />
            )}

            {checkPermission('createLatestBusinessBankAccountsCsv') && (
              <AsideMenuItem
                to='/bank-account-setting'
                title='Bank Account Setting'
                isMinified={isMinified}
              />
            )}
            {checkPermission('getBusinessAccountStatement') && (
              <AsideMenuItem
                to='/transaction-statement'
                title='Transaction Statement'
                isMinified={isMinified}
              />
            )}

            {/* <AsideMenuItem to='/dispute' title='Dispute' />  */}
          </AsideMenuItemWithSubMain>
        )
      }
    </>
  )
}
